import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <section className="footer">
      <p className="footer__name">Потапова Евгения Юрьевна</p>
      <div className="footer__section-number">
        <div className="footer__phone-icon"></div>
        <a 
          href="tel:+79213582437" 
          className="footer__number"
          title="Позвонить"
        >
          +7 921-358-24-37
        </a>
      </div>
      <p className="footer__city">Санкт-Петербург — 2026 год</p>
      <div className="footer__section-email">
        <div className="footer__email-icon"></div>
        <a 
          href="mailto:teacher-psychologist@mail.ru"
          className="footer__email"
          title="Написать письмо"
        >
          teacher-psychologist@mail.ru
        </a>
      </div>
    </section>
  );
}
